import { Seo } from "../components/seo/Seo";
import { Breadcrumbs } from "../components/seo/Breadcrumbs";
import { FAQ } from "../components/FAQ";

export function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ — Veelgestelde vragen | Makers Hub"
        description="Antwoorden op de meest gestelde vragen over Makers Hub workshops: leeftijd, prijs, voorkennis, wat meebrengen, locatie, annulatie, verzekering."
        path="/faq"
      />
      <div className="container" style={{ paddingTop: 32 }}>
        <Breadcrumbs
          items={[
            { label: "Home", to: "/" },
            { label: "FAQ" },
          ]}
        />
      </div>
      <FAQ />
    </>
  );
}
